module.exports = __webpack_public_path__ + "static/WEDDING E&M-572-912aafb67e6c790953e6c56a3be86274.jpg";